/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { projectLayout } from '@jira/platform__layouts-project-layout/src/index.tsx';
import {
	composeLayouts,
	type Layout,
} from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';

export const polarisProjectLayout: Layout = composeLayouts(projectLayout);
